import { internalAxios } from '../../utils/axios/internal';

export const get = async (fetchUrl, id = []) => {
  const response = await internalAxios.post(fetchUrl, { id });
  return response.data;
};
